import {t} from 'i18next';

export default function(seconds = Number(seconds)) {
    const d = Math.floor(seconds / (3600*24)),
    h = Math.floor(seconds % (3600*24) / 3600),
    m = Math.floor(seconds % 3600 / 60),
    s = Math.floor(seconds % 60),
    dDisplay = d > 0 ? t('defaults.time.days', {count: d})+" " : "",
    hDisplay = h > 0 ? t('defaults.time.hours', {count: h})+" " : "",
    mDisplay = m > 0 ? t('defaults.time.minutes', {count: m})+" " : "",
    sDisplay = s > 0 ? t('defaults.time.seconds', {count: s})+" " : "";
    return dDisplay + hDisplay + mDisplay + sDisplay;
}